export default "__VITE_ASSET__CDgD0Ydh__"